import { Routes } from "@angular/router";

import { environment } from "src/environments/environment";

export const museumBuildingsRoutes: Routes = [
  {
    path: "",
    title: "MUSEUM_BUILDINGS.TITLE",
    loadComponent: () =>
      import("./pages/museums-buildings-list/museums-buildings-list.component").then((m) => m.MuseumsBuildingsListComponent),
  },
];

export const museumBuildingsManagementRoutes: Routes = [
  {
    path: "add",
    title: "MUSEUM_BUILDINGS.ADD",
    canMatch: [() => !environment.production],
    loadComponent: () =>
      import("./pages/add-edit-museum-buildings/add-edit-museum-building.component").then((m) => m.AddEditMuseumBuildingComponent),
  },
  {
    path: "edit/:id",
    title: "MUSEUM_BUILDINGS.EDIT",
    loadComponent: () =>
      import("./pages/add-edit-museum-buildings/add-edit-museum-building.component").then((m) => m.AddEditMuseumBuildingComponent),
  },
];
